module.exports = __webpack_public_path__ + "img/5388ef9.png";